/* Selv Rituel · v6 · île de suivi du panier (29 sept. 2026).
   - Visible dès que le panier contient quelque chose (rendu serveur), repliée ; dépliée 6 s après chaque ajout
     (cart:added), puis repliée. Un appui sur le sac replie/déplie ; un appui sur le corps ouvre le tiroir.
   - Relue après chaque changement du panier (update:cart:drawer) : HTML de la section selv-cart-island déjà
     présent dans la réponse, sinon GET <url>?section_id=selv-cart-island. La jauge part de son ancien niveau.
   - Se retire pendant que le tiroir est ouvert (aria-hidden de #CartDrawer) ; la croix la ferme jusqu'au
     prochain ajout (sessionStorage).
   - Paliers cadeaux (v18.4, 3 nov. 2026) : quand un point du mini-rail s'allume (palier franchi), l'île se déplie
     6 s pour montrer le message du prochain palier, comme après un ajout. */
(() => {
  'use strict';
  if (window.SelvCartIsland) return;
  const d = document;
  const root = d.querySelector('[data-selv-ci-root]');
  if (!root) return;
  const ID = 'selv-cart-island';
  const KEY = 'selv-ci-off';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let timer = 0;
  let wantExpanded = false;
  let seq = 0;

  const island = () => root.querySelector('[data-selv-ci]');
  const closed = () => { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } };
  const setClosed = (v) => { try { if (v) sessionStorage.setItem(KEY, '1'); else sessionStorage.removeItem(KEY); } catch (e) { /* sans effet */ } };
  const drawerOpen = () => { const dr = d.getElementById('CartDrawer'); return !!dr && dr.getAttribute('aria-hidden') === 'false'; };
  // Bandeau de confidentialité de Shopify (#shopify-pc__banner), lui aussi en bas de l'écran : l'île s'efface tant
  // qu'il est affiché, puis revient quand la cliente a répondu.
  const bannerOn = () => {
    const b = d.getElementById('shopify-pc__banner');
    if (!b || b.hidden) return false;
    const r = b.getBoundingClientRect();
    return r.height > 0 && r.width > 0 && getComputedStyle(b).visibility !== 'hidden';
  };
  const covered = () => drawerOpen() || bannerOn();

  const fold = (mini) => { const el = island(); if (el) el.classList.toggle('is-mini', mini); };
  // html.selv-ci-on : l'île est réellement affichée (la zone des messages « Ajouté » se décale au-dessus)
  const flag = () => { const el = island(); d.documentElement.classList.toggle('selv-ci-on', !!(el && el.classList.contains('is-on') && !el.classList.contains('is-away'))); };
  const show = (expanded) => {
    const el = island();
    if (!el || closed()) return;
    el.classList.toggle('is-away', covered());
    clearTimeout(timer);
    if (expanded) {
      fold(false);
      timer = setTimeout(() => fold(true), 6000);
    } else {
      fold(true);
    }
    // l'entrée part d'en bas : la classe d'affichage arrive après le premier rendu
    requestAnimationFrame(() => { el.classList.add('is-on'); flag(); });
  };
  const away = () => { const el = island(); if (el) el.classList.toggle('is-away', covered()); flag(); };

  const swap = (markup) => {
    const next = new DOMParser().parseFromString(markup, 'text/html').querySelector('[data-selv-ci-root]');
    if (!next) return false;
    const old = island();
    const from = old ? old.style.getPropertyValue('--p') : '';
    const wasOn = !!(old && old.classList.contains('is-on'));
    const dotsBefore = old ? old.querySelectorAll('.selv-ci__dot.is-on').length : 0;
    root.innerHTML = next.innerHTML;
    const el = island();
    if (!el) { flag(); return true; } // panier vide : plus rien à montrer
    if (wasOn) el.classList.add('is-on');
    if (old && el.querySelectorAll('.selv-ci__dot.is-on').length > dotsBefore) wantExpanded = true;
    if (from && !reduce) {
      const to = el.style.getPropertyValue('--p');
      el.style.setProperty('--p', from);
      void el.offsetWidth;
      el.style.setProperty('--p', to);
    }
    return true;
  };
  const refresh = async (res) => {
    const s = ++seq;
    let markup = res && res.sections && res.sections[ID];
    if (!markup || !swap(markup)) {
      try {
        const u = new URL(window.location.href);
        u.search = '';
        u.hash = '';
        u.searchParams.set('section_id', ID);
        const r = await fetch(u.toString(), { headers: { Accept: 'text/html' } });
        if (!r.ok) return;
        markup = await r.text();
        if (s !== seq || !swap(markup)) return;
      } catch (e) { return; }
    }
    const expanded = wantExpanded;
    wantExpanded = false;
    show(expanded);
  };

  const bus = window.eventBus;
  if (bus && typeof bus.on === 'function') {
    bus.on('cart:added', () => { setClosed(false); wantExpanded = true; show(true); });
    bus.on('update:cart:drawer', (res) => refresh(res));
  }
  const dr = d.getElementById('CartDrawer');
  if (dr && 'MutationObserver' in window) new MutationObserver(away).observe(dr, { attributes: true, attributeFilter: ['aria-hidden'] });
  if ('MutationObserver' in window) {
    // le bandeau de confidentialité apparaît, change de classe ou disparaît : on suit
    new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.target === d.body && m.type === 'childList') { away(); return; }
        if (m.target.id === 'shopify-pc__banner' || (m.target.closest && m.target.closest('#shopify-pc__banner'))) { away(); return; }
      }
    }).observe(d.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
  }

  root.addEventListener('click', (e) => {
    const close = e.target.closest && e.target.closest('[data-selv-ci-close]');
    if (close) {
      const el = island();
      if (el) el.classList.remove('is-on');
      setClosed(true);
      flag();
      return;
    }
    const bag = e.target.closest && e.target.closest('.selv-ci__bag');
    if (bag) {
      // le sac replie ou déplie sans ouvrir le tiroir
      e.preventDefault();
      const el = island();
      if (!el) return;
      const mini = el.classList.contains('is-mini');
      clearTimeout(timer);
      fold(!mini);
      if (mini) timer = setTimeout(() => fold(true), 6000);
      return;
    }
    const open = e.target.closest && e.target.closest('[data-selv-ci-open]');
    if (open && bus && typeof bus.emit === 'function') {
      e.preventDefault();
      bus.emit('open:cart:drawer', { scrollToTop: true });
    }
  });

  window.addEventListener('pageshow', (e) => { if (e.persisted) refresh(null); });
  if (island()) setTimeout(() => show(false), 300);
  window.SelvCartIsland = { refresh, show };
})();
